import { useEffect } from 'react';

import { formatToDollarsString } from 'helpers';
import useRedeemCredit from 'services/discounts/useRedeemCredit';
import useSubscriptions from 'services/general/subscriptionsList';

import { LinkButton, Spinfinity, Typography } from 'components';
import { urls } from '@repo/app-constants';
import CopyField from 'components/CopyField/CopyField';
import SlideUpModal from 'components/Modal/SlideUpModal';

import styles from './RedeemCreditModal.module.scss';

type RedeemCreditModalProps = {
  toggle: () => void;
  showModal: boolean;
  onRedeemSuccess?: () => void;
};
const RedeemCreditModal = ({ showModal, toggle, onRedeemSuccess }: RedeemCreditModalProps) => {
  const { isAnyTinyPlus, isTinyPlus } = useSubscriptions();
  const {
    data: redemption,
    mutate,
    isSuccess,
    isError,
    isPending: isLoading,
  } = useRedeemCredit();
  useEffect(() => {
    if (showModal && !redemption && !isSuccess && !isError && !isLoading)
      mutate();
  }, [redemption, mutate, showModal, isSuccess, isError, isLoading]);

  useEffect(() => {
    if (isSuccess && onRedeemSuccess) {
      onRedeemSuccess();
    }
  }, [isSuccess, onRedeemSuccess]);

  return (
    <SlideUpModal toggle={toggle} showModal={showModal} title='Store credit'>
      {showModal && isLoading && <Spinfinity />}
      {showModal && redemption && (
        <div className={styles.modalContent}>
          <Typography variant='body-s'>Congratulations!</Typography>
          <Typography variant='body-s'>
            {' '}
            You have redeemed {formatToDollarsString(
              redemption.amount / 100,
            )}{' '}
            in store credit 🎉
          </Typography>
          <Typography variant='body-s'>
            Use this discount code on checkout to redeem it:
          </Typography>
          <CopyField value={redemption.discount_code} name='discount code' />
          <LinkButton
            className={'mt-auto'}
            color='green'
            width='full'
            href={`${
              isAnyTinyPlus
                ? isTinyPlus
                  ? urls.CHECKOUT_WITH_KIT_TINY_PLUS
                  : urls.CHECKOUT_WITH_KIT_TINY_PLUS_PROGRAM_OR_PROACTIVE
                : urls.CHECKOUT_WITH_KIT_NON_TINY_PLUS
            }?discount=${redemption.discount_code}`}
            external
          >
            Order your kit
          </LinkButton>
        </div>
      )}
    </SlideUpModal>
  );
};

export default RedeemCreditModal;
